export default __webpack_public_path__ + "6a37adddcf179d3d86e61de46ccd4da8.png";